import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { BillSchema } from '../base/index.js';
export const ReadBillsByEntityApiSchema = {
    params: z.object({
        entityId: CornSchema,
    }),
    response: z.object({ bills: BillSchema.array() }),
};
export const ReadBillsByEntityPathSchema = ReadBillsByEntityApiSchema.params;
export const ReadBillsByEntityRequestSchema = ReadBillsByEntityPathSchema;
export const ReadBillsByEntityResponseSchema = ReadBillsByEntityApiSchema.response;
